import { IconBase } from './IconBase'

type IconEmptyNotificationProps = React.ComponentProps<'svg'>

export const IconEmptyNotification = (props: IconEmptyNotificationProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 160 160" {...props}>
      <path
        d="M90 23.3337H70V16.667C70 11.1437 74.4767 6.66699 80 6.66699C85.5233 6.66699 90 11.1437 90 16.667V23.3337Z"
        fill="url(#paint0_linear_10037_60569)"
      />
      <path
        d="M130 70C130 42.3867 107.613 20 80 20C52.3867 20 30 42.3867 30 70C30 71.3 30 113.333 30 113.333H130C130 113.333 130 71.3 130 70Z"
        fill="#F5BE00"
      />
      <path
        d="M130 113.333H29.9999L17.0833 118.5C14.8166 119.406 13.3333 121.6 13.3333 124.036C13.3333 127.33 16.0033 130 19.2966 130H140.703C143.997 130 146.667 127.33 146.667 124.036C146.667 121.6 145.183 119.406 142.917 118.5L130 113.333Z"
        fill="url(#paint1_linear_10037_60569)"
      />
      <path
        d="M93.3334 130C93.3334 137.363 87.3634 143.333 80.0001 143.333C72.6367 143.333 66.6667 137.363 66.6667 130H93.3334Z"
        fill="url(#paint2_linear_10037_60569)"
      />
      <path
        d="M140 73.3333C138.16 73.3333 136.667 71.8433 136.667 69.9999C136.667 58.8599 133.403 48.0666 127.23 38.7833C126.21 37.2499 126.627 35.1833 128.16 34.1599C129.697 33.1399 131.767 33.5566 132.78 35.0899C139.683 45.4733 143.333 57.5433 143.333 69.9999C143.333 71.8433 141.84 73.3333 140 73.3333Z"
        fill="#EA2E3D"
      />
      <path
        d="M20.0001 73.3338C18.1601 73.3338 16.6667 71.8438 16.6667 70.0004C16.6667 57.5438 20.3167 45.4738 27.2201 35.0904C28.2401 33.5571 30.3101 33.1438 31.8401 34.1604C33.3734 35.1838 33.7901 37.2504 32.7701 38.7838C26.5967 48.0671 23.3334 58.8604 23.3334 70.0004C23.3334 71.8438 21.8401 73.3338 20.0001 73.3338Z"
        fill="#EA2E3D"
      />
      <path
        d="M153.333 73.3336C151.493 73.3336 150 71.8436 150 70.0003C150 55.007 145.32 40.707 136.463 28.6403C135.373 27.157 135.693 25.0703 137.177 23.9803C138.66 22.8936 140.747 23.2136 141.837 24.697C151.537 37.9136 156.667 53.5803 156.667 70.0003C156.667 71.8436 155.173 73.3336 153.333 73.3336Z"
        fill="#EA2E3D"
      />
      <path
        d="M6.66659 73.3336C4.82659 73.3336 3.33325 71.8436 3.33325 70.0002C3.33325 53.5802 8.46325 37.9136 18.1633 24.6936C19.2499 23.2136 21.3366 22.8869 22.8233 23.9769C24.3066 25.0669 24.6266 27.1536 23.5366 28.6369C14.6799 40.7069 9.99992 55.0069 9.99992 70.0002C9.99992 71.8436 8.50659 73.3336 6.66659 73.3336Z"
        fill="#EA2E3D"
      />
      <rect
        x="13.3333"
        y="15.0625"
        width="6.66667"
        height="186.466"
        transform="rotate(-45 13.3333 15.0625)"
        fill="#1B1D2A"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10037_60569"
          x1="80"
          y1="6.64366"
          x2="80"
          y2="23.3503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDE00" />
          <stop offset="1" stopColor="#FFD000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10037_60569"
          x1="79.9999"
          y1="113.31"
          x2="79.9999"
          y2="130.016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDE00" />
          <stop offset="1" stopColor="#FFD000" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10037_60569"
          x1="80.0001"
          y1="143.063"
          x2="80.0001"
          y2="129.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.486" stopColor="#FBC300" />
          <stop offset="1" stopColor="#DBAA00" />
        </linearGradient>
      </defs>
    </IconBase>
  )
}
